export const QUERY_KEYS = {
  currentUser: "currentUser",
  getProjects:"getProjects",
  getProjectDetails:"getProjectDetails",
  organisation:"organisation",
  taskById:"taskById",
  taskMamber:"taskMamber",
  allTask:"allTask",
  myTasks: "myTasks",
  allNotification:"allNotification",
  allKanbanColumn:"allKanbanColumn",
  ProjectMember:"getProjectMembers",
  DemoProject:"getDemoProject",
  getLocation:"getLocation",
  paymentStatus:"paymentStatus",
  paymentInvoice:"paymentInvoice",
  paymentsubscription:"subscription",
  paymentInvoicePortal:"paymentInvoicePortal",
  risk:"risk",
  demoRisk:"demoRisk",
  ribbon:"ribbon",
  setting:"setting",
  portfolios:"portfolios",
  allToken:"allToken",
  collaboratorVerificationToken:"collaboratorVerificationToken",
  getAvailabilityByUserID:"getAvailabilityByUserID",
  getProjectsNocal:"getProjectsNocal",

} as const;
